/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "CantRenounceOwnerRole",
        type: "error",
    },
    {
        inputs: [],
        name: "ContractAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "depositId",
                type: "uint256",
            },
        ],
        name: "InvalidDepositStatus",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidReceiptContract",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "redemptionId",
                type: "uint256",
            },
        ],
        name: "InvalidRedemption",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidTokenContract",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "minimum",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "requested",
                type: "uint256",
            },
        ],
        name: "MinimumAmountRequired",
        type: "error",
    },
    {
        inputs: [],
        name: "MintingFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "UnauthorizedBeneficiary",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "DepositReceiptExchange",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "DepositReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "DepositsReconciled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
        ],
        name: "DepositsWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "FundsReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "ManagementInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "oldAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newAmount",
                type: "uint256",
            },
        ],
        name: "MinimumDepositUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "oldAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newAmount",
                type: "uint256",
            },
        ],
        name: "MinimumRedemptionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "RedemptionReceiptExchange",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "RedemptionRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
        ],
        name: "RedemptionsReconciled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        inputs: [],
        name: "ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BENEFICIARY_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "OPERATOR_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WHITELIST_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositReceiptContract",
        outputs: [
            {
                internalType: "contract Receipt",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAllDeposits",
        outputs: [
            {
                internalType: "uint256[]",
                name: "keys",
                type: "uint256[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "enum DepositStatus",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRate",
                        type: "uint256",
                    },
                ],
                internalType: "struct Deposit[]",
                name: "values",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAllRedemptions",
        outputs: [
            {
                internalType: "uint256[]",
                name: "keys",
                type: "uint256[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "enum RedemptionStatus",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "exchangeRate",
                        type: "uint256",
                    },
                ],
                internalType: "struct Redemption[]",
                name: "values",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMembers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
        ],
        name: "markDepositsReconciled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "exchangeRate",
                type: "uint256",
            },
        ],
        name: "markRedemptionsReconciled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumDepositAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumRedemptionAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "onUTYTokenReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionReceiptContract",
        outputs: [
            {
                internalType: "contract Receipt",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_depositReceiptContract",
                type: "address",
            },
        ],
        name: "setDepositReceiptContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minDepositAmount",
                type: "uint256",
            },
        ],
        name: "setMinDepositAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minRedemptionAmount",
                type: "uint256",
            },
        ],
        name: "setMinRedemptionAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_redemptionReceiptContract",
                type: "address",
            },
        ],
        name: "setRedemptionReceiptContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unityContract",
                type: "address",
            },
        ],
        name: "setUnityContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unityContract",
        outputs: [
            {
                internalType: "contract Unity",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "withdrawDeposits",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class Management__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
Management__factory.bytecode = _bytecode;
Management__factory.abi = _abi;
//# sourceMappingURL=Management__factory.js.map